import InstallerView from './InstallerView';
export default InstallerView;
